import { getMockDataByKeys } from "./mock";

export const NOTIFY = {
  name: "notify",
  uuid: 0x7201,
  properties: ["read", "write", "notify"],
};
export function generateMockIFTFNofifyData(): DomianControl.IFTFNotifyData {
  const data = getMockDataByKeys([
    /**
     * 前轴电机端驱动力
     */
    "UIRx_MotTq_FA",
    /**
     * 后轴电机端驱动力
     */
    "UIRx_MotTq_RA",
    /**
     * FL制动力矩
     */
    "UIRx_WhlBrkTqAct_FL_BCh1",
    /**
     * FR制动力矩
     */
    "UIRx_WhlBrkTqAct_FR_BCh1",
    /**
     * RL制动力矩
     */
    "UIRx_WhlBrkTqAct_RL_BCh1",
    /**
     * RR制动力矩
     */
    "UIRx_WhlBrkTqAct_RR_BCh1",
  ]);
  return data;
}
